import { types, actions } from './requests'
export const TOOLBAR_TYPES = {
    ...types('TOOLBAR'),
}
export const TOOLBAR_ACTIONS = {
    ...actions('TOOLBAR'),
}
